"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = _interopRequireDefault(require("./styles"));
var _pushToDataLayer = _interopRequireDefault(require("../../../utils/pushToDataLayer"));
const Phone = props => {
  const classes = (0, _styles.default)(props);
  const {
    number
  } = props;
  const handlePhone = () => {
    var _window, _window$location;
    (0, _pushToDataLayer.default)({
      event: "buttonClick",
      name: "phone_number",
      placement: "header",
      eventLabel: (_window = window) === null || _window === void 0 ? void 0 : (_window$location = _window.location) === null || _window$location === void 0 ? void 0 : _window$location.pathname
    });
  };
  return /*#__PURE__*/_react.default.createElement("a", {
    onClick: handlePhone,
    rel: "nofollow",
    href: `tel:${number}`,
    className: classes.phoneNum
  }, number);
};
var _default = Phone;
exports.default = _default;